<p-table
  #dt2
  [value]="inspirationalMessages"
  dataKey="id"
  [rows]="10"
  styleClass="p-datatable-users p-datatable-striped"
  [globalFilterFields]="['message', 'isActive']"
  [scrollable]="true"
  scrollHeight="1000px"
  dataKey="message"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template pTemplate="caption">
    <div class="flex">
      <span class="p-input-icon-right to-right">
        <p-button
          label="Add Inspirational Message"
          icon="pi pi-user"
          styleClass="p-button-success"
          iconPos="right"
          (onClick)="showAddInspirationalMessage()"
        ></p-button>
        <i class="pi pi-search to-right"></i>
        <input
          pInputText
          type="text"
          (input)="dt2.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Search keyword"
        />
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th id="message" class="table-col-width-small">
        <div class="p-d-flex p-jc-between p-ai-center">Message</div>
      </th>
      <th id="lastName" class="table-col-width-small">
        <div class="p-d-flex p-jc-between p-ai-center">Active</div>
      </th>
      <th id="actions" class="table-col-width-large">
        <div class="p-d-flex p-jc-between p-ai-center">Actions</div>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-inspirationalMessage>
    <tr>
      <td>
        <span>{{ inspirationalMessage.message }}</span>
      </td>
      <td>
        <span>{{ inspirationalMessage.isActive | status }}</span>
      </td>
      <td>
        <p-button
          label="Edit"
          styleClass="p-button-warning p-button-sm"
          icon="pi pi-file-edit"
          iconPos="right"
          (onClick)="showEditInspirationalMessage(inspirationalMessage)"
        ></p-button>
        <p-button
          *ngIf="inspirationalMessage.isActive"
          label="Disable"
          styleClass="p-button-danger p-button-sm"
          icon="pi pi-lock"
          iconPos="right"
          (onClick)="swapEnableInspirationalMessage(inspirationalMessage)"
        ></p-button>
        <p-button
          *ngIf="!inspirationalMessage.isActive"
          label="Enable"
          styleClass="p-button-primary p-button-sm"
          icon="pi pi-lock-open"
          iconPos="right"
          (onClick)="swapEnableInspirationalMessage(inspirationalMessage)"
        ></p-button>
        <p-button
          label="Delete"
          styleClass="p-button-danger p-button-sm"
          icon="pi pi-trash"
          iconPos="right"
          (onClick)="showDeleteInspirationalMessage(inspirationalMessage)"
        ></p-button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7">No inspirational messages found.</td>
    </tr>
  </ng-template>
</p-table>
